import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { tenantService } from "../../Services/tenant.service";

const LogoUpdate = ({ show, handleHide, tenantId, setUpdate }) => {
  const { t: translator } = useTranslation();
  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState("");
  const [logoValidationMsg, setLogoValidationMsg] = useState("");

  useEffect(() => {
    tenantService
      .getById(tenantId)
      .then((res) => {
        if (res.data.logoImage != null) setLogoPreview(res.data.logoImage);
      })
      .catch((err) => console.log(err));
  }, [show]);

  const checkIsImage = (inputFile) => {
    if (!inputFile) return true;
    if (inputFile.type !== "image/jpeg") return false;
    return loadImage(inputFile)
      .then((res) => {
        if (res.width === 400 && res.height == 200) {
          setLogo(inputFile);
          setLogoPreview(res.src);
        } else setLogoValidationMsg("ValidationMsg-ImageJpg");
        return res.width === 400 && res.height === 200 ? true : false;
      })
      .catch((err) => console.log(err));
  };

  async function loadImage(uploadedFile) {
    return new Promise((resolve) => {
      let img = new Image();
      img.onload = function () {
        resolve({ width: img.width, height: img.height, src: img.src });
      };
      img.src = window.URL.createObjectURL(uploadedFile);
    });
  }

  const handleSubmit = () => {
    if (logo) {
      tenantService
        .updateLogo(tenantId, logo)
        .then((res) => {
          handleHide();
          setUpdate(new Date());
        })
        .catch((err) => console.log(err));
    }
  };

  const removeLogo = () => {
    setLogoPreview("");
    setLogo(null);
  };

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header>
        <Modal.Title>{translator("Update-Logo")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="form-group">
            <label>Logo</label>
            <br />
            {logoPreview === "" ? (
              <>
                <input
                  type="file"
                  className="form-control-file"
                  name="logo"
                  onChange={() =>
                    checkIsImage(document.getElementsByName("logo")[0].files[0])
                  }
                />
                <p className="text-danger">{translator(logoValidationMsg)}</p>
              </>
            ) : (
              <img
                src={logoPreview}
                alt="logo"
                style={{ maxWidth: 400, maxHeight: 200 }}
              />
            )}
            {logoPreview !== "" && (
              <div className="form-group mt-2">
                <button
                  className="btn btn-outline-secondary"
                  onClick={removeLogo}
                >
                  <i className="fas fa-trash-alt text-secondary"></i>
                </button>
                &nbsp;{translator("Remove-Logo")}
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHide}
        >
          {translator("Btn-Cancel")}
        </button>
        <button
          onClick={handleSubmit}
          type="button"
          disabled={logoPreview === "" || logo === null ? true : false}
          className="btn btn-primary"
        >
          {translator("Logo-Confirm")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoUpdate;
